import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_ENSENANZA_ID,
  GET_ENSENANZAS,
  REMOVE_ENSENANZA,
} from '../../graphql/actions/ensenanza';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import School from '@material-ui/icons/School';
import PeopleAlt from '@material-ui/icons/PeopleAlt';
import ThumbUpAlt from '@material-ui/icons/ThumbUpAlt';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import NavPills from '../../components/UI/NavPills/NavPills';
import Button from '../../components/UI/CustomButtons/Button';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Badge from '../../components/UI/Badge/Badge';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import EnseñanzaDel from './EnseñanzaDel';

import mariyaGeorgieva from '../../assets/img/profile02.jpg';

import sectionDataStyle from '../../assets/jss/coscef/views/enseñanzaSections/sectionDataStyle';

const useStyles = makeStyles(sectionDataStyle);

const EnseñanzaData = (props) => {
  const classes = useStyles();
  const [numEnsenanzas, setNumEnsenanzas] = useState(30);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [eliminarEnsenanzaModal, setEliminarEnsenanzaModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_ENSENANZA_ID,
      data: { getEnsenanzaId: id },
    });
    setEliminarEnsenanzaModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarEnsenanzaModal(false);
    // ok
    setNumEnsenanzas(30);
    setField('createdAt');
    setOrder('ASC');
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removeEnsenanza) setEliminarEnsenanzaModal(false);
    else console.log('Error eliminando enseñanza.');
  };

  const updateCacheDel = (cache, id) => {
    const { getEnsenanzas } = cache.readQuery({
      query: GET_ENSENANZAS,
      variables: {
        paginate: {
          numEnsenanzas: numEnsenanzas,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoEnsenanzas = getEnsenanzas.ensenanzas.filter(
      (ensenanza) => ensenanza.id !== id
    );

    if (getEnsenanzas && nuevoEnsenanzas) {
      cache.writeQuery({
        query: GET_ENSENANZAS,
        variables: {
          paginate: {
            numEnsenanzas: numEnsenanzas,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getEnsenanzas: {
            ensenanzas: nuevoEnsenanzas,
          },
        },
      });
    }
  };

  const {
    loading: loadingEnsenanzas,
    error: errorEnsenanzas,
    data: dataEnsenanzas,
  } = useQuery(GET_ENSENANZAS, {
    variables: {
      paginate: {
        numEnsenanzas: numEnsenanzas,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [
    eliminarEnsenanza,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_ENSENANZA, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const removeEnsenanzaHandler = (id) => {
    eliminarEnsenanza({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionNavEnsenanza = null;
  let seccionBotonAdd = null;
  let removeModal = (
    <EnseñanzaDel
      show={eliminarEnsenanzaModal}
      close={eliminarCloseModalHandler}
      removeEnsenanza={removeEnsenanzaHandler}
    />
  );

  if (loadingEnsenanzas) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;

  if (errorEnsenanzas) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title + ' ' + classes.textCenter}>
              Error al buscar las enseñanzas en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionNavEnsenanza = null;
    seccionBotonAdd = null;

    showNotification = errorEnsenanzas.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEnsenanzas ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataEnsenanzas && dataEnsenanzas.getEnsenanzas) {
    const { getEnsenanzas } = dataEnsenanzas;
    //console.log(getEnsenanzas);
    if (getEnsenanzas.ensenanzas.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title + ' ' + classes.textCenter}>
                No se encontraron enseñanzas, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionNavEnsenanza = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'enseñanza'} />
        </div>
      ) : null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                Cursos, talleres y entrenamientos
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionNavEnsenanza = (
        <div className={classes.profileTabs}>
          <NavPills
            alignCenter
            color='dark'
            tabs={getEnsenanzas.ensenanzas.map((ensenanza) => ({
              key: ensenanza.node._id,
              tabIcon:
                ensenanza.node.tipo === 'Cursos'
                  ? School
                  : ensenanza.node.tipo === 'Talleres'
                  ? PeopleAlt
                  : ThumbUpAlt,
              tabButton: ensenanza.node.tipo,
              tabContent: (
                <GridContainer justify='center'>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    className={classes.gridItem}
                  >
                    <div className={classes.marginTop10}>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={5}
                        className={classes.gridItem}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: ensenanza.node.contenido,
                          }}
                        />
                        {props.isAuth ? (
                          <div className={classes.textCenter}>
                            <Button
                              round
                              justIcon
                              color='white'
                              onClick={(e) => {
                                e.preventDefault();
                                props.history.push(
                                  '/editar-enseñanza/' + ensenanza.node._id
                                );
                              }}
                            >
                              <Icon>mode_edit</Icon>
                            </Button>
                            <Button
                              round
                              justIcon
                              color='white'
                              onClick={() =>
                                eliminarShowModalHandler(ensenanza.node._id)
                              }
                            >
                              <Delete />
                            </Button>
                          </div>
                        ) : null}
                      </GridItem>
                    </div>
                    <div className={classes.marginTop10}>
                      <h3 className={classes.title}>{ensenanza.node.tipo}</h3>
                      <GridContainer className={classes.collections}>
                        <GridItem xs={12} sm={4} md={4}>
                          <Card
                            background
                            style={{
                              backgroundImage: 'url(' + mariyaGeorgieva + ')',
                            }}
                          >
                            <CardBody background className={classes.cardBody}>
                              <Badge color='warning' className={classes.badge}>
                                Spring 2016
                              </Badge>
                              <a href='#pablo'>
                                <h2 className={classes.cardTitleWhite}>
                                  Stilleto
                                </h2>
                              </a>
                            </CardBody>
                          </Card>
                        </GridItem>
                      </GridContainer>
                    </div>
                  </GridItem>
                </GridContainer>
              ),
            }))}
          />
        </div>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'enseñanza'} />
        </div>
      ) : null;
    }
  }
  if (dataRemove && dataRemove.removeEnsenanza) {
    const { removeEnsenanza } = dataRemove;
    if (removeEnsenanza.success && removeEnsenanza.code === '200') {
      showNotification = (
        <Notification
          key={removeEnsenanza.code}
          mostrar={removeEnsenanza.success ? true : false}
          msg={removeEnsenanza.message}
          stt={removeEnsenanza.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionNavEnsenanza}
              {seccionBotonAdd}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(EnseñanzaData);
